module.exports = __webpack_public_path__ + "img/c08_buildingtechvanisgrip_Normal_ua.e9ced88f.webp";